define((require) => {
    "use strict";

    const {defaults, extend}   = require("underscore");
    const ChannelSetupItemView = require("ui/publish/channelSetup/ChannelSetupItemView");
    const MessageNode          = require("services/messageNode/MessageNode");
    const MessageTypes         = require("ui/publish/MessageTypes");
    const template             = require("ui/projects/publish/ProjectChannelSetupItemView.tpl");
    const Tooltip              = require("ui/common/Tooltip");

    /**
     * Subclass of ChannelSetupItemView representing the item view of the Channel dashboard element in a project context.<p>
     * @class ProjectDashboardChannelSetupItemView
     * @see ChannelSetupItemView
     */
    return ChannelSetupItemView.extend("ProjectDashboardChannelSetupItemView", {

        template,

        /**
         * @type {ProjectModel}
         */
        _project: null,

        templateHelpers() {
            const parentTemplateHelpers = this.__super();

            return defaults({
                showChannelActionsPanel: this.options.showChannelActionsPanel,
                isLocked: this._project.containsInferredAsset(this.model.get("id"))
            }, parentTemplateHelpers);
        },

        ui() {
            return extend({}, ChannelSetupItemView.prototype.ui, {
                noDetachChannel: ".no-detach",
                detachChannel: ".detach"
            });
        },

        events() {
            return extend({}, ChannelSetupItemView.prototype.events, {
                "click @ui.noDetachChannel": (event) => {
                    // TODO: Please document why this is needed?
                    event.stopPropagation();
                },

                "click @ui.detachChannel": "_detachChannelClickHandler"
            });
        },

        initialize() {
            this.__super();

            this._project = this.options.projectContext.project;
        },

        onShow() {
            this.__super();

            Tooltip.add(this.ui.noDetachChannel, {
                placement: "top",
                width: 260
            });

            Tooltip.add(this.ui.detachChannel, {
                placement: "top",
                width: !this._allowedToPublish ? 180 : 100
            });
        },

        onClose() {
            this.__super();

            Tooltip.remove(this.ui.detachChannel);
        },

        _detachChannelClickHandler(event) {
            // Prevents to trigger the click event on the parent class, so that the Manual Channel lightbox does not get open in this view.
            event.stopPropagation();
            if (this._allowedToPublish) {
                const channelModel = this.model;

                return this._project.detach(channelModel)
                    .then(() => {
                        this.collection.remove(channelModel);

                        // TODO still needed?
                        // Make sure we update the DnD view if opened because this may update
                        // how channels are rendered there, even with empty schedules...
                        const node = this.options.node();
                        if (node) {
                            node.post({action: MessageTypes.POPULATE_CHANNELS, receiver: "toolbar", selectors: MessageNode.Message.Selectors.NO_QUEUE});
                        }

                        this.trigger("detach", channelModel);
                    })
                    .always(() => {
                        this.trigger("close");
                    });
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/publish/ProjectDashboardChannelSetupItemView.js